import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IBreadcrumb } from './breadcrumb-model';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent {
  @Input() data: IBreadcrumb[];  // To get the data to display on the breadcrumb

  constructor() {
    //console.log(this.data);
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/breadcrumb/breadcrumb.component.ts